import { ForgotPasswordPresentation } from './components/ForgotPasswordPresentation';

export const ForgotPasswordPage = (): JSX.Element => {
    return (
       <ForgotPasswordPresentation/>
    )
};